import styled from 'styled-components';

import { createColumnHelper } from '@tanstack/react-table';

import { StatusChip } from 'components/referrals/referralsTableColumns';
import CircularProgress from 'components/shared/CircularProgress';
import { simpleDateAtTime } from 'lib/date';
import { capitalize } from 'lib/util';
import Admission from 'models/reviews/Admission';
import colors from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

const columnHelper = createColumnHelper<Admission>();

export default function admissionsTableColumns() {
  return [
    columnHelper.accessor((row) => row.data.patient?.name, {
      id: 'patient',
      header: 'Patient Name',
      cell: (info) => {
        return (
          <PatientNameContainer>
            {info.row.original.isProcessing && (
              <div>
                <CircularProgress size={16} thickness={2} color={colors.primaryBlue} />
              </div>
            )}
            <BodySmall fontWeight='700' color={colors.primaryBlue}>
              {info.getValue() || <>&mdash;</>}
            </BodySmall>
          </PatientNameContainer>
        );
      },
      size: 100,
    }),
    columnHelper.accessor((row) => row.data.referralSource, {
      id: 'referralSource',
      header: 'Referral Source',
      cell: (info) => {
        const value = info.getValue();
        if (!value) return <>&mdash;</>;
        return <div>{value}</div>;
      },
      size: 100,
    }),
    columnHelper.accessor((row) => row.group, {
      id: 'group',
      header: 'SNF',
      cell: (info) => {
        const value = info.getValue();
        if (!value) return <>&mdash;</>;
        return <div>{value.name}</div>;
      },
      size: 100,
    }),
    columnHelper.accessor((row) => row.updatedAt, {
      id: 'updatedAt',
      header: 'Last Updated',
      cell: (info) => (info.getValue() ? simpleDateAtTime(info.getValue() ?? '') : <>&mdash;</>),
      size: 100,
    }),
    columnHelper.accessor((row) => row.createdBy?.fullName, {
      id: 'createdBy',
      header: 'Created By',
      cell: (info) => {
        const value = info.getValue();
        if (!value) return <>&mdash;</>;
        return <div>{value}</div>;
      },
      size: 100,
    }),
    columnHelper.accessor((row) => row.status, {
      id: 'status',
      header: 'Status',
      cell: (info) => (
        <StatusChip $status={info.row.original.status}>
          {info.row.original.rejected ? 'Denied' : capitalize(info.row.original.status)}
        </StatusChip>
      ),
      size: 100,
    }),
  ];
}

const PatientNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
